import { useParams } from 'react-router-dom';
import Header from './Header';
import { SendFill, ArrowLeftShort } from 'react-bootstrap-icons';
import { Input } from 'antd';
import { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Data from '../data/Data';

function ProjectChat() {
    const { id } = useParams();
    const [project, setProject] = useState({});
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const chatBodyRef = useRef(null);
    const navigate = useNavigate();

    const fetchProject = useCallback(async () => {
        setProject(await Data.fetchProjectById(id));
    }, [id]);

    const fetchMessages = useCallback(() => {
        setMessages([
            {
                'type': 'received',
                'message': 'hello'
            },
            {
                'type': 'my',
                'message': 'hello my name is Levi'
            },
            {
                'type': 'received',
                'message': 'hello'
            },
            {
                'type': 'my',
                'message': 'hello my name is Levi'
            },
            {
                'type': 'received',
                'message': 'hello'
            },
            {
                'type': 'my',
                'message': 'hello my name is Levi'
            },
            {
                'type': 'received',
                'message': 'hello'
            },
            {
                'type': 'my',
                'message': 'hello my name is Levi'
            },
            {
                'type': 'received',
                'message': 'hello'
            },
            {
                'type': 'my',
                'message': 'hello my name is Levi'
            },
            {
                'type': 'received',
                'message': 'hello'
            },
            {
                'type': 'my',
                'message': 'hello my name is Levi'
            },
            {
                'type': 'received',
                'message': 'hello'
            },
            {
                'type': 'my',
                'message': 'hello my name is Levi'
            },
        ]);
    }, []);

    useEffect(() => {
        fetchProject();
        fetchMessages();
    }, [fetchProject, fetchMessages]);

    useEffect(() => {
        scrollChatToBottom();
    }, [messages])
    
    const scrollChatToBottom = () => {
        if (chatBodyRef.current)
        chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    };

    const handleSendMessage = () => {
        if (message !== '') {
            console.log(message);

            // send message logic

            setMessage('');
        }
    };

    return (
        <div>
            <Header background authButton sticky />
            <div className='ProjectChat'>
                <div className='container'>
                    <div className='row chat-header'>
                        <div className='col-12 d-flex align-items-center'>
                            <ArrowLeftShort className='btn-back' onClick={() => navigate('/dashboard')} />
                            <div>{project.title}</div>
                        </div>
                    </div>
                    <div className='row chat-body' ref={chatBodyRef}>
                        <div className='col-12'>
                            {messages && messages.map((element, index) => (
                                <div key={index} className={'d-flex ' + (element.type === 'received' ? 'justify-content-start' : 'justify-content-end')}>
                                    <p>{element.message}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='row chat-footer'>
                        <div className='col-12 d-flex align-items-center'>
                            <Input className='me-2' placeholder='Type your message here...' onChange={(e) => setMessage(e.target.value)} value={message} onPressEnter={handleSendMessage} />
                            <button className='btn btn-primary btn-sm' onClick={handleSendMessage}>
                                <SendFill />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProjectChat;